import React from 'react';
import PropTypes from 'prop-types';
import Prices from '@digital-retail/cross-prices';

const CrossPrice = ({ regionCode, priceList, discountBadge, promotions, userSegments, isUserLoggedIn, cesSegment }) => {
  return (
    <Prices
      priceList={priceList}
      regionCode={regionCode}
      discountBadge={discountBadge}
      promotions={promotions}
      userSegments={userSegments}
      isUserLoggedIn={isUserLoggedIn}
      cesSegment={cesSegment}
    />
  );
};

CrossPrice.propTypes = {
  priceList: PropTypes.arrayOf(PropTypes.object).isRequired,
  regionCode: PropTypes.string,
  discountBadge: PropTypes.object,
  promotions: PropTypes.array,
  userSegments: PropTypes.array,
  isUserLoggedIn: PropTypes.bool,
  cesSegment: PropTypes.object,
};

CrossPrice.defaultProps = {
  regionCode: 'cl',
  discountBadge: {},
  promotions: [],
  userSegments: [],
  isUserLoggedIn: false,
  cesSegment: {},
};

export default CrossPrice;
export { CrossPrice };
